import { render, staticRenderFns } from "./CopyToBrowse.vue?vue&type=template&id=8ee83b44&scoped=true"
import script from "./CopyToBrowse.vue?vue&type=script&lang=js"
export * from "./CopyToBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee83b44",
  null
  
)

export default component.exports